import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {
  IGetApplicationSettings,
  IUpdateApplicationSettingsRequest,
} from '../interfaces/application-settings.interface';
import { ControlerEnum } from '../enums/controler.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationSettingsService {
  apiBaseUrl: string = environment.apiBaseUrl;
  private http = inject(HttpClient);

  getApplicationSettings(): Observable<HttpResponse<IGetApplicationSettings>> {
    return this.http.get<IGetApplicationSettings>(
      `${this.apiBaseUrl}/${ControlerEnum.Offer}/applicationSettings`,
      { observe: 'response' },
    );
  }

  updateApplicationSettings(
    model: IUpdateApplicationSettingsRequest,
  ): Observable<HttpResponse<void>> {
    return this.http.put<void>(
      `${this.apiBaseUrl}/${ControlerEnum.Offer}/applicationSettings`,
      model,
      { observe: 'response' },
    );
  }
}
